import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, FormikProps } from 'formik';
import { Button, FormControl } from '@material-ui/core';
import ArchiveIcon from '@material-ui/icons/ArchiveOutlined';

import { RunReportInput } from 'api';
import { Loaders } from 'components';

interface IProps {
  reportUrl: string;
  working: boolean;
  onDownload: () => void;
}

interface IPropsEnhanced extends IProps {
  formik: FormikProps<RunReportInput>;
}

const Actions: FC<IPropsEnhanced> = ({ formik, reportUrl, working, onDownload }) => {
  const { t } = useTranslation();
  const { isValid } = formik;

  useEffect(() => {
    if (reportUrl) {
      onDownload();
    }
  }, [reportUrl]);

  function renderDownload() {
    return (
      <Button
        color="primary"
        variant="contained"
        component="a"
        href={reportUrl}
        startIcon={<ArchiveIcon />}>
        {t('groups:downloadReport')}
      </Button>
    );
  }

  function renderGenerate() {
    if (working) {
      return <Loaders.Standard height={38} />;
    }

    return (
      <Button type="submit" color="primary" variant="outlined" disabled={!isValid}>
        {t('groups:generateReport')}
      </Button>
    );
  }

  return (
    <FormControl fullWidth margin="normal">
      {reportUrl ? renderDownload() : renderGenerate()}
    </FormControl>
  );
};

export default connect<IProps>(Actions);
